import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"z-index":"1002"},
  class: "flex items-center bg-dark fixed top-0 left-0 w-full h-14 shadow-elevation bg-opacity-90 px-2"
}
const _hoisted_2 = { class: "mr-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "close", -1)
const _hoisted_4 = { class: "text-lightText flex items-center space-x-4" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "ml-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "file_download", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "zoom_in", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "zoom_out", -1)
const _hoisted_10 = {
  style: {"z-index":"1001"},
  class: "mt-14 fixed top-1/2 transform -translate-y-2/3 -translate-x-1/2 left-1/2"
}
const _hoisted_11 = { class: "relative w-max" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "fixed h-screen w-screen top-0 left-0 bg-dark bg-opacity-60",
      style: {"z-index":"1000"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewerClose')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Btn, {
          class: "mr-2",
          variant: 'icon',
          outline: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('viewerClose')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.filename), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Btn, {
          class: "mr-2",
          loading: _ctx.downloading,
          variant: 'icon',
          outline: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('download')))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_Btn, {
          class: "",
          variant: 'icon',
          outline: true,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onZoom(1)))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_Btn, {
          variant: 'icon',
          outline: true,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onZoom(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.isLoading || _ctx.downloading)
          ? (_openBlock(), _createBlock(_component_Spinner, {
              key: 0,
              variant: 'primary',
              size: 'xl'
            }))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "m-auto",
              style: _normalizeStyle({ width: _ctx.width + '%', 'max-width': '300% !important' }),
              src: _ctx.base64Source
            }, null, 12, _hoisted_12))
      ])
    ])
  ], 64))
}